import React from 'react';
import { CheckCircle2, CalendarCheck, Phone } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';
import { clinicInfo } from '../../mock';

export const AppointmentConfirmation = ({ appointment, onReset }) => (
  <Card className="border-none shadow-xl max-w-2xl mx-auto" data-testid="appointment-confirmation">
    <CardContent className="p-6 md:p-10 text-center">
      <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center mx-auto mb-5">
        <CheckCircle2 className="text-green-600" size={32} />
      </div>
      <h3 className="text-xl md:text-2xl font-bold text-darkBrown mb-2">Your slot is reserved</h3>
      <p className="text-sm md:text-base text-gray-600 mb-6">
        A confirmation email is on its way to <span className="font-semibold">{appointment.email}</span>.
        Our team will call you to finalize the visit.
      </p>

      <div className="bg-warmBeige/60 rounded-xl p-5 text-left space-y-2 mb-6">
        <Row label="Date" value={appointment.dateLabel} testId="confirm-date" />
        <Row label="Time" value={appointment.timeLabel} testId="confirm-time" />
        <Row label="Visit type" value={appointment.visitTypeLabel} testId="confirm-visit-type" />
        <Row label="Confirmation #" value={appointment.confirmationCode} testId="confirm-code" />
      </div>

      <div className="flex flex-col sm:flex-row gap-3 justify-center">
        <Button
          data-testid="book-another-btn"
          onClick={onReset}
          className="bg-primaryOrange hover:bg-accentOrange text-white"
        >
          <CalendarCheck size={18} className="mr-2" /> Book another visit
        </Button>
        <Button asChild variant="outline" className="border-primaryOrange text-primaryOrange">
          <a href={`tel:${clinicInfo.phone}`} data-testid="confirm-call-link">
            <Phone size={18} className="mr-2" /> Call {clinicInfo.phone}
          </a>
        </Button>
      </div>
    </CardContent>
  </Card>
);

const Row = ({ label, value, testId }) => (
  <div className="flex justify-between gap-4 text-sm md:text-base">
    <span className="text-gray-500">{label}</span>
    <span className="font-semibold text-darkBrown text-right" data-testid={testId}>{value}</span>
  </div>
);
